import ProgressRing from '@adsk/alloy-react-progress-ring';
import ContentLoader from '@adsk/alloy-react-content-loader';
import { CSSObject } from 'styled-components';

export enum LoaderStyle {
  Spinny,
  Text,
}

const DEFAULT_CONTENT_LOADER_STYLE = { maxWidth: 130 };

export type InlineLoaderProps = {
  loaderStyle?: LoaderStyle;
  contentLoaderHeight?: number;
  style?: CSSObject;
  className?: string;
};

export const InlineLoader = ({
  loaderStyle = LoaderStyle.Spinny,
  contentLoaderHeight = 12,
  style,
  className,
}: InlineLoaderProps) => {
  const contentLoadClassName = className ? `visual_test_ignore ${className}` : 'visual_test_ignore';
  if (loaderStyle === LoaderStyle.Spinny) {
    return <ProgressRing size={ProgressRing.SIZES.SMALL} style={style} className={className} />;
  }

  const finalContentLoaderStyle =
    style === undefined
      ? DEFAULT_CONTENT_LOADER_STYLE
      : { ...DEFAULT_CONTENT_LOADER_STYLE, ...style };

  return (
    <ContentLoader
      height={contentLoaderHeight}
      width="100%"
      style={finalContentLoaderStyle}
      className={contentLoadClassName}
    >
      <rect rx={6} ry={6} height="100%" width="100%" />
    </ContentLoader>
  );
};
